
// @ constants
const actionTypes = require('constants/actionTypes');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

const getOpenYoungChildDetailsError = error => ({
    type: actionTypes.OPENYOUNG_DASHBOARD_CHILD_DETAILS_ERROR,
    payload: {
        error
    }
});

const getOpenYoungChildDetailsRequest = () => ({
    type: actionTypes.OPENYOUNG_DASHBOARD_CHILD_DETAILS_REQUEST
});

const getOpenYoungChildDetailsSuccess = openYoungChildDetails => ({
    type: actionTypes.OPENYOUNG_DASHBOARD_CHILD_DETAILS_SUCCESS,
    payload: {
        openYoungChildDetails
    }
});

const getChildDetails = childInfo => dispatch => {
    dispatch(getOpenYoungChildDetailsRequest());
    const params = {
        query: {
            childContractDetail: childInfo
        }
    }
    return APIPost({
        dispatch,
        endpoint: 'openYoungChildDetails',
        params
    })
        .then(response => {
            dispatch(getOpenYoungChildDetailsSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getOpenYoungChildDetailsError(response.error.description));
            } else {
                throw response;
            }
        });
}

module.exports = {
    getChildDetails,
};
